import React, { useEffect, useRef, useState } from "react";

const SKILL_CATEGORIES = [
  {
    title: "Languages",
    icon: "fa fa-code",
    color: "#f7768e",
    skills: ["Go", "Python", "TypeScript", "Java", "C++", "PHP"],
  },
  {
    title: "AI / ML",
    icon: "fa fa-cogs",
    color: "#bb9af7",
    skills: ["LangChain", "LangGraph", "RAG", "Agentic AI", "OpenAI", "Embeddings"],
  },
  {
    title: "Backend",
    icon: "fa fa-server",
    color: "#7aa2f7",
    skills: ["Node.js", "FastAPI", "Django", "Spring Boot", "GraphQL", "gRPC"],
  },
  {
    title: "Frontend",
    icon: "fa fa-desktop",
    color: "#e0af68",
    skills: ["React.js", "Next.js", "Angular", "TypeScript"],
  },
  {
    title: "Databases",
    icon: "fa fa-database",
    color: "#9ece6a",
    skills: ["PostgreSQL", "MongoDB", "Redis", "DynamoDB", "Cassandra", "MySQL"],
  },
  {
    title: "Cloud & DevOps",
    icon: "fa fa-cloud",
    color: "#7dcfff",
    skills: ["AWS", "GCP", "Docker", "Kubernetes", "Terraform"],
  },
  {
    title: "Messaging",
    icon: "fa fa-exchange",
    color: "#ff9e64",
    skills: ["Kafka", "AWS SQS/SNS", "RabbitMQ", "Redis Pub/Sub"],
  },
  {
    title: "Competitive Programming",
    icon: "fa fa-trophy",
    color: "#f7768e",
    skills: ["Codeforces Specialist", "CodeChef 4-Star", "LeetCode 1821"],
  },
];

const SkillCategory = ({ category, delay }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          obs.unobserve(e.target);
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`skill-cat-card ${visible ? "skill-cat-visible" : ""}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="skill-cat-header">
        <i className={category.icon} style={{ color: category.color }} />
        <h3>{category.title}</h3>
      </div>
      <div className="skill-pills">
        {category.skills.map((skill, i) => (
          <span
            key={skill}
            className="skill-pill"
            style={{
              borderColor: category.color,
              animationDelay: `${delay + i * 60}ms`,
            }}
          >
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
};

const Resume = ({ data }) => {
  if (!data) return null;

  return (
    <section id="resume" className="skills-section">
      <div className="skills-section-inner">
        <h1 className="skills-heading">
          <span>Skills</span>
        </h1>
        <p className="skills-subtitle">{data.skillmessage}</p>
        <div className="skill-cats-grid">
          {SKILL_CATEGORIES.map((cat, i) => (
            <SkillCategory key={cat.title} category={cat} delay={i * 80} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Resume;
